export const ENTITY_TYPE = {
  USER: 'user',
  GROUP: 'group',
  M2M: 'm2m',
} as const;

export const MEMBERSHIP_MODE = {
  MEMBERS: 'members',
  OWNERS: 'owners',
} as const;

export type EntityType = (typeof ENTITY_TYPE)[keyof typeof ENTITY_TYPE];

export type IdentityType = Exclude<EntityType, typeof ENTITY_TYPE.GROUP>;

export type MembershipMode = (typeof MEMBERSHIP_MODE)[keyof typeof MEMBERSHIP_MODE];
